import { Box, Typography, TextField } from "@mui/material";

import TypeSelector from "../../components/TypeSelector";
import SizeSelector from "../../components/SizeSelector";
import PresentationSelector from "../../components/PresentationSelector";
import ContainerOptionSelector from "../../components/ContainerOptionSelector";
import LocationsSelector from "../../components/LocationsSelector";
import PrimaryClassificationSelector from "../../components/PrimaryClassificationSelector";
import SecondaryClassificationSelector from "../../components/SecondaryClassificationSelector";
import ExpertRatingsSection from "./ExpertRatingsSection";

export default function BundleMetafieldsSection({ values, setValues }) {
  const setMetafield = (key, value) =>
    setValues((prev) => ({
      ...prev,
      metafields: { ...(prev.metafields || {}), [key]: value },
    }));

  return (
    <>
      {/* Classification and Origin */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Classification and Origin
        </Typography>

        <Box sx={{ mb: 2 }}>
          <TypeSelector values={values} setValues={setValues} />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 2,
            mb: 2,
          }}
        >
          <SizeSelector
            value={values.metafields?.size || ""}
            onChange={(value) => setMetafield("size", value)}
          />
          <PresentationSelector
            value={values.metafields?.presentation}
            onChange={(value) => setMetafield("presentation", value)}
          />
          <ContainerOptionSelector
            value={values.metafields?.container}
            onChange={(value) => setMetafield("container", value)}
          />
          <TextField
            label="Vintage"
            type="number"
            value={values.metafields?.vintage || ""}
            onChange={(e) => setMetafield("vintage", e.target.value)}
            fullWidth
            size="small"
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 2,
            mb: 2,
          }}
        >
          <Box sx={{ gridColumn: "1 / span 3" }}>
            <LocationsSelector values={values} setValues={setValues} />
          </Box>
          <TextField
            label="ABV"
            type="number"
            value={values.metafields?.abv || ""}
            onChange={(e) => setMetafield("abv", e.target.value)}
            fullWidth
            size="small"
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
            mt: 3,
          }}
        >
          <PrimaryClassificationSelector
            value={values.metafields?.primary_classification}
            onChange={(value) => setMetafield("primary_classification", value)}
          />
          <SecondaryClassificationSelector
            value={values.metafields?.secondary_classification}
            onChange={(value) => setMetafield("secondary_classification", value)}
          />
        </Box>
      </Box>

      {/* Expert Ratings */}
      <ExpertRatingsSection values={values} setValues={setValues} />
    </>
  );
}
